import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ApexCharts from 'react-apexcharts';
import { MININGWEBSERVICE } from '../../CoreDataService';

const NetworkHashrateGraph = ({ selectedPoolCoin = 'BTC' }) => {
  const [graphData, setGraphData] = useState([]);
  const [unit, setUnit] = useState('');
  const [loading, setLoading] = useState(false);

  const formatDate = (inputDate) => {
    const parts = inputDate.split('/');
    return new Date(parts[2], parts[1] - 1, parts[0]);
  };

  useEffect(() => {
    fetchGraphData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPoolCoin]);

  const fetchGraphData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('access_token');
      const response = await axios.get(
        `${MININGWEBSERVICE}/getHashRateHistory/${selectedPoolCoin}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `BEARER ${token}`,
          },
        }
      );

      const data = response.data.getHashRateHistory || [];
      const unit = response.data.unit;
      setUnit(unit);

      const formatted = data.map((item) => [formatDate(item.doc), item.hashrate]);
      setGraphData(formatted);
    } catch (error) {
      console.error('Error fetching hashrate graph data:', error);
    } finally {
      setLoading(false);
    }
  };

  const chartOptions = {
    series: [
      {
        name: '',
        data: graphData,
      },
    ],
    chart: {
      type: 'area',
      height: 350,
      zoom: {
        type: 'x',
        enabled: true,
        autoScaleYaxis: true,
      },
      toolbar: {
        autoSelected: 'zoom',
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 0,
    },
    title: {
      text: `Network HashRate ( ${unit} )`,
      align: 'center',
      style: {
        color: '#FFF',
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.5,
        opacityTo: 0,
        stops: [0, 90, 100],
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => val.toFixed(2),
        style: {
          colors: '#FFF',
        },
      },
      title: {
        text: `Network HashRate ( ${unit} )`,
        style: {
          color: '#FFF',
        },
      },
    },
    xaxis: {
      type: 'datetime',
      labels: {
        rotate: -45,
        style: {
          colors: '#FFF',
        },
      },
      title: {
        text: 'Day',
        style: {
          color: '#FFF',
        },
      },
    },
    tooltip: {
      shared: false,
      y: {
        formatter: (val) => `${val.toFixed(0)} ${unit}`,
      },
    },
    grid: {
      borderColor: '#90A4AE',
    },
  };

  return (
    <div id="hashrate">
      {loading && (
        <>
          <div className="top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-1 flex flex-col items-center justify-center"></div>
          <div className="loading style-2">
            <div className="loading-wheel"></div>
          </div>
        </>
      )}
      <div id="chart">
        {!loading && <ApexCharts options={chartOptions} series={chartOptions.series} type="area" height={350} />}
      </div>
    </div>
  );
};

export default NetworkHashrateGraph;
